import React, { useState } from 'react'
import Search from '../../../../components/FlowConfigurationForms/String/Search/Search'
import { Close } from '@material-ui/icons'
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import DashBoardService from '../../../../services/DashBoardService/DashBoardService'
import { alertState } from '../../../../recoil-store/recoil-state'
import { useSetRecoilState } from 'recoil'

const CreateDashBoard = ({ handleClose, dashBoardTabs, setDashBoardTabs, setSelectedDashboard, label }) => {
    const { t } = useTranslation();
    const [dashboardName, setDashboardName] = useState("")
    const setAlert = useSetRecoilState(alertState);


    const onSubmit = async () => {
        if (dashboardName) {
            const response = await DashBoardService.createDashBoard({ name: dashboardName })
            if (response.status) {
                setDashBoardTabs((pre) => {
                    const newTabs = JSON.parse(JSON.stringify(pre))
                    return [...newTabs, { id: response.id, name: dashboardName }]
                })
                setSelectedDashboard({ id: response.id, name: dashboardName })
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(label + response.message),
                    severity: 'success'
                }))
                handleClose()
            }
            else {
                return setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t(label + response.message),
                    severity: 'error'
                }))
            }
        }
    }

    const onChange = async (event) => {
        if (event.target.value && event.target.value.length > 50) {
            return setAlert(alert => ({
                ...alert,
                show: true,
                message: t("CONTENT.GENERAL.CHARACTER-LIMIT", { limit: 50 }),
                severity: 'error'
            }))
        }
        setDashboardName(event.target.value)
    }

    return (
        <Dialog
            id="db-create-dashboard-dialog"
            data-test="autom-add-new"
            className="autom-group"
            open={true}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: "20%",
                    maxWidth: "95%",
                    // width: "70%",
                    height: "fit-content",
                    borderRadius: " 4px",
                    padding: "4px 22px 40px 22px"
                },
            }}
        >
            <DialogTitle id="db-create-dashboard-dialog-title">
                <div id="about-title">
                    <h4 className="db-configure-name-title no-text-wrap">{t(label + "CREATE-DASHBOARD")}</h4>
                    <Close className="autom-group-close-button logs-close-icon" onClick={handleClose} style={{ fontSize: "1rem" }} />
                </div>

            </DialogTitle>
            <DialogContent className='db-create-dashboard-container'>
                <div className="form-element">
                    <div className="modal-text add-group-name">
                        <div>{t(label + "DASHBOARD-NAME")}<span className="mandatory-field">*</span> </div>
                    </div>
                    <TextField
                        id="filled-size-small"
                        autoFocus
                        style={{
                            backgroundColor: "#fff",
                            width: "100%",
                            marginBottom: "14px"
                        }}
                        value={dashboardName}
                        onChange={onChange}
                        variant="outlined"
                        size="small"
                        inputProps={{ style: { fontSize: 12 } }}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                }}>
                    <button
                        type="button"
                        onClick={onSubmit}
                        data-test="createautom-button"
                        className={`button-save`}
                        style={{
                            width: "128px",
                            height: "27px",
                            borderRadius: "4px",
                            boxShadow: "0px 0px 8px -3px rgba(0, 0, 0, 0.25)"
                        }}
                    >
                        {t("CONTENT.AUTOMS-LIST.CREATE")}
                    </button>
                </div>
            </DialogActions>

        </Dialog>
    )
}

export default CreateDashBoard